import { apiRequest } from './client';
import { getApiToken, tryGetApiToken } from './authToken';

export async function callApi(path, payload = {}, { auth = true } = {}) {
  const token = auth ? await getApiToken() : await tryGetApiToken();
  const data = await apiRequest(path, {
    method: 'POST',
    body: payload,
    token: token || undefined,
  });
  return { data };
}

export async function getApi(path, { auth = false } = {}) {
  const token = auth ? await getApiToken() : await tryGetApiToken();
  return apiRequest(path, { token: token || undefined });
}
